import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProdutoList.css';
import api from '../services/api';
import { toast } from 'react-toastify';
import Pagination from '../components/Pagination';

const PAGE_SIZE = 10;

function ClienteList() {
  const [clientes, setClientes] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [page, setPage]       = useState(1);
  const [sortKey, setSortKey] = useState(null);
  const [sortDir, setSortDir] = useState('asc');
  const navigate = useNavigate();

  useEffect(() => { fetchClientes(); }, []);

  const fetchClientes = async () => {
    try {
      const token = localStorage.getItem('access_token');
      const res = await api.get('/clientes/', { headers: { Authorization: `Bearer ${token}` } });
      setClientes(res.data);
    } catch {
      toast.error('Erro ao carregar os clientes.');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Excluir este cliente?')) return;
    try {
      const token = localStorage.getItem('access_token');
      await api.delete(`/clientes/${id}/`, { headers: { Authorization: `Bearer ${token}` } });
      setClientes(clientes.filter((c) => c.id !== id));
      toast.success('Cliente excluído.');
    } catch (err) {
      toast.error(err.response?.data?.erro || 'Erro ao excluir o cliente.');
    }
  };

  const filtered = clientes.filter((c) =>
    c.nome.toLowerCase().includes(search.toLowerCase()) ||
    c.email.toLowerCase().includes(search.toLowerCase())
  );
  const sorted = sortKey
    ? [...filtered].sort((a, b) => {
        const va = a[sortKey] ?? ''; const vb = b[sortKey] ?? '';
        const cmp = typeof va === 'string' ? va.localeCompare(vb, 'pt-BR') : Number(va) - Number(vb);
        return sortDir === 'asc' ? cmp : -cmp;
      })
    : filtered;
  const totalPages = Math.ceil(sorted.length / PAGE_SIZE);
  const paginated  = sorted.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  const handleSort = (key) => {
    if (sortKey === key) setSortDir((d) => (d === 'asc' ? 'desc' : 'asc'));
    else { setSortKey(key); setSortDir('asc'); }
    setPage(1);
  };

  return (
    <div className="produto-page">

      <div className="produto-page-header">
        <div className="produto-page-title-row">
          <h2 className="produto-page-title">Clientes</h2>
          <div className="produto-tabs">
            <span className="produto-tab active">Lista de Clientes</span>
            <span className="produto-tab" onClick={() => navigate('/clientes/novo')}>
              Novo Cliente
            </span>
          </div>
        </div>
        <div className="produto-header-actions">
          <div className="produto-search-wrap">
            <span className="material-symbols-outlined">search</span>
            <input
              type="text"
              placeholder="Buscar cliente..."
              value={search}
              onChange={(e) => { setSearch(e.target.value); setPage(1); }}
            />
          </div>
          <button className="prd-btn-primary" onClick={() => navigate('/clientes/novo')}>
            <span className="material-symbols-outlined">person_add</span>
            Novo Cliente
          </button>
        </div>
      </div>

      <div className="prd-card prd-table-card">
        <div className="prd-card-accent" />
        <div className="prd-table-toolbar">
          <span className="prd-table-count">
            {filtered.length} cliente{filtered.length !== 1 ? 's' : ''}
          </span>
          <button className="prd-icon-btn" onClick={fetchClientes} title="Atualizar">
            <span className="material-symbols-outlined">refresh</span>
          </button>
        </div>
        <div className="prd-table-wrap">
          <table className="prd-table">
            <thead>
              <tr>
                <th className={`th-sort${sortKey === 'nome' ? ' sort-active' : ''}`} onClick={() => handleSort('nome')}>
                  Nome <span className="material-symbols-outlined th-sort-icon">{sortKey === 'nome' ? (sortDir === 'asc' ? 'arrow_upward' : 'arrow_downward') : 'unfold_more'}</span>
                </th>
                <th className={`th-sort${sortKey === 'email' ? ' sort-active' : ''}`} onClick={() => handleSort('email')}>
                  Email <span className="material-symbols-outlined th-sort-icon">{sortKey === 'email' ? (sortDir === 'asc' ? 'arrow_upward' : 'arrow_downward') : 'unfold_more'}</span>
                </th>
                <th>Telefone</th>
                <th>Endereço</th>
                <th className="right">Ações</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array.from({ length: 4 }).map((_, i) => (
                  <tr key={i}>
                    {Array.from({ length: 5 }).map((__, j) => (
                      <td key={j}><div className="skeleton" /></td>
                    ))}
                  </tr>
                ))
              ) : filtered.length === 0 ? (
                <tr>
                  <td colSpan={5} className="prd-empty">
                    {search ? 'Nenhum cliente encontrado.' : 'Nenhum cliente cadastrado.'}
                  </td>
                </tr>
              ) : (
                paginated.map((c) => (
                  <tr key={c.id}>
                    <td>
                      <div className="td-name-wrap">
                        <div className="td-thumb" style={{ borderRadius: '50%', background: '#1B263B', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <span className="material-symbols-outlined" style={{ fontSize: '16px', color: '#cca730' }}>person</span>
                        </div>
                        <span className="td-name">{c.nome}</span>
                      </div>
                    </td>
                    <td>{c.email}</td>
                    <td>{c.telefone || '—'}</td>
                    <td className="td-desc">{c.endereco || '—'}</td>
                    <td className="right">
                      <div className="td-actions">
                        <button
                          className="prd-icon-btn"
                          onClick={() => navigate(`/pedidos?cliente=${c.id}`)}
                          title="Ver pedidos"
                        >
                          <span className="material-symbols-outlined">shopping_cart</span>
                        </button>
                        <button
                          className="prd-icon-btn"
                          onClick={() => navigate(`/orcamentos?cliente=${c.id}`)}
                          title="Ver orçamentos"
                        >
                          <span className="material-symbols-outlined">payments</span>
                        </button>
                        <button
                          className="prd-icon-btn"
                          onClick={() => navigate(`/clientes/editar/${c.id}`)}
                          title="Editar"
                        >
                          <span className="material-symbols-outlined">edit</span>
                        </button>
                        <button
                          className="prd-icon-btn prd-icon-btn--danger"
                          onClick={() => handleDelete(c.id)}
                          title="Excluir"
                        >
                          <span className="material-symbols-outlined">delete</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <Pagination page={page} totalPages={totalPages} onPageChange={(p) => { setPage(p); window.scrollTo(0,0); }} />
      </div>
    </div>
  );
}

export default ClienteList;
